export const QRAssign = {
    GET_QRCODESNOTMAPPED: "GET_QRCODESNOTMAPPED"



}
